import { cn } from '@/libs/shadcn';

interface AppSuspenseFallbackProps {
  containerClassName?: string;
}
export default function AppSuspenseFallback({
  containerClassName,
}: AppSuspenseFallbackProps) {
  return (
    <div
      className={cn(
        'fixed inset-0 bg-sidebar flex items-center justify-center',
        containerClassName
      )}
    >
      <span className="text-2xl font-semibold tracking-tight text-sidebar-foreground">
        Pintu Berdikari
      </span>
    </div>
  );
}
